module.exports = "<app-main-navigation></app-main-navigation> \r\n<router-outlet></router-outlet>\r\n"